/**
 * A rule's name as the Monitor shows it (ADR-0100): its own, or the default list's in the reader's
 * language. The inbox, its filter and the rules tab name rules the same way.
 */
import { useTranslation } from 'react-i18next'

export function useRuleLabel(): (name: string | null) => string {
  const { t } = useTranslation()
  return name => name ?? t('cases.monitor.rules.watchedName')
}
